import { Snackbar } from './Snackbar';

export type { TypeSnackbarProps } from './types';
export default Snackbar;
